module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Bz1t38/tc-custom/9781504099882.jpg?1728726136596",
      "alt": "This image is the cover for the book Other Bridget"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Other Bridget\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A feisty book-loving heroine, two hot heroes, and side plots about characters you care about . . . this lovely romance will keep you turning pages.” —Paige Toon, bestselling author of "), _c('i', [_vm._v("Seven Summers")])]), _c('br'), _c('br'), _vm._v(" Librarian Bridget Jones, named after the famous fictional heroine, was raised on a remote farm with only her mother’s romance novels for company."), _c('br'), _c('br'), _vm._v(" Now, living alone in the city, Bridget is a hopeless bookaholic and believes that anyone who doesn’t like reading just hasn’t met the right book yet. If only fixing her love life was that simple."), _c('br'), _c('br'), _vm._v(" After handsome Italian barista Fabio catches her eye, Bridget prays she won’t ruin things. But when her cranky neighbor Sully insists on making life tricky, she is faced with a new obstacle. Why is he going to so much trouble to drive her ’round the bend?"), _c('br'), _c('br'), _vm._v(" With the help of a colorful cast of friends, Bridget decides to put both men to the test. But will mixing romance and fiction lead to her happily ever after?"), _c('br'), _c('br'), _vm._v(" “Entertaining and charming, Rachael Johns is arguably the best romantic writer in Australia.” —"), _c('i', [_vm._v("The Australian")]), _c('br'), _c('br'), _vm._v(" “Pure sunshine for the soul. I just loved it!” —Tess Woods, author of "), _c('i', [_vm._v("The Venice Hotel")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rachael Johns\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0